import * as _ from "lodash";

class NmbrsController {
    private nmbrsEmployeeAddress: any;
    private nmbrsEmployeeFunction: any;
    private function: any;
    private functions: any;
    private activeTabIndex: number;

    constructor() {
        'ngInject';
    }

    public $onInit = () => {
        this.activeTabIndex = 0;
        
    }

    public $onChange = () => {
        if(this.nmbrsEmployeeFunction){
            this.function = _.find(this.functions, {code: this.nmbrsEmployeeFunction.code});
        }
    }
}

export const nmbrsComponent = {
    bindings: {
        nmbrsEmployee: "<",
        nmbrsEmployeeAddress: "<",
        nmbrsEmployeeBankAccount: "<",
        nmbrsEmployeeFunction: "<",
        nmbrsEmployeeSalary: "<",
        nmbrsEmployeeContract: "<",
        functions: "<"
    },
    controller: NmbrsController,
    template: require('./nmbrs.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/nmbrs/nmbrs.component.ts